import { Card, Flex, Typography } from "antd";
import React from "react";
import CountUp from "react-countup";

interface StatisticsCardProps {
  icon: React.ReactNode;
  value: string;
  label: string;
  iconBgColor?: string;
  iconColor?: string;
  titleColor?: string;
}
const StatisticsCard = ({
  icon,
  value,
  label,
  iconBgColor = "#74baff",
  iconColor = "#0984e3",
  titleColor = "#0984e3",
}: StatisticsCardProps) => (
  <Card size="small" style={{ borderRadius: "20px" }} hoverable>
    <Flex gap={10} align="">
      <span
        style={{
          background: iconBgColor + "4a",
          borderRadius: 4,
          padding: 4,
          height: "30px",
        }}
      >
        {React.cloneElement(icon as React.ReactElement, {
          color: iconColor,
          style: { position: "relative", top: 2 },
        })}
      </span>
      <Flex vertical>
        <Typography.Title level={4} style={{ color: titleColor, margin: 0 }}>
          {/* {value} */}
          <CountUp duration={3} start={1} end={Number(value)} />
        </Typography.Title>
        <Typography.Title
          level={5}
          style={{ color: "gray", margin: 0, fontSize: 14 }}
        >
          {label}
        </Typography.Title>
      </Flex>
    </Flex>
  </Card>
);

export default StatisticsCard;
